const STORAGE_KEY = 'lexikonActiveLetter'

function rememberLetter(letter) {
	try {
		sessionStorage.setItem(STORAGE_KEY, letter)
	} catch (e) {
		// sessionStorage unavailable (e.g. private browsing) - ignore
	}
}

function getRememberedLetter() {
	try {
		return sessionStorage.getItem(STORAGE_KEY)
	} catch (e) {
		return null
	}
}

export function lexikon() {
	const list = document.querySelector('[data-lexikon-list]')
	const nav = document.querySelector('[data-lexikon-nav]')
	const input = document.querySelector('[data-lexikon-search]')

	if (!list || !nav) return

	const groups = list.querySelectorAll('[data-lexikon-group]')
	const navButtons = nav.querySelectorAll('[data-letter]')

	function showLetter(letter) {
		groups.forEach((group) => {
			group.querySelectorAll('[data-lexikon-item]').forEach((item) => item.classList.remove('is-hidden'))
			group.classList.toggle('is-active', group.dataset.letter === letter)
		})
		navButtons.forEach((button) => {
			button.classList.toggle('is-active', button.dataset.letter === letter)
		})
	}

	function showSearch(query) {
		groups.forEach((group) => {
			let hasMatch = false

			group.querySelectorAll('[data-lexikon-item]').forEach((item) => {
				const matches = item.dataset.search.includes(query)
				item.classList.toggle('is-hidden', !matches)
				if (matches) hasMatch = true
			})

			group.classList.toggle('is-active', hasMatch)
		})
	}

	navButtons.forEach((button) => {
		button.addEventListener('click', () => {
			if (input) input.value = ''
			rememberLetter(button.dataset.letter)
			showLetter(button.dataset.letter)
		})
	})

	groups.forEach((group) => {
		group.querySelectorAll('[data-lexikon-item] a[href]').forEach((link) => {
			link.addEventListener('click', () => {
				rememberLetter(group.dataset.letter)
			})
		})
	})

	const rememberedLetter = getRememberedLetter()
	if (rememberedLetter && list.querySelector(`[data-lexikon-group][data-letter="${rememberedLetter}"]`)) {
		showLetter(rememberedLetter)
	}

	if (input) {
		input.addEventListener('input', () => {
			const query = input.value.trim().toLowerCase()

			if (!query) {
				const activeButton = nav.querySelector('[data-letter].is-active') || navButtons[0]
				showLetter(activeButton ? activeButton.dataset.letter : null)
				return
			}

			showSearch(query)
		})
	}
}
